export default class HeaderGeneric {
	constructor(config) {
		this.el = config.el || document.querySelectorAll("body");
		this.headers = document.querySelectorAll(".header");
		this.timeout = null;
		this.mobileBreakpoint = 992;
		this.init();
	}
	init() {
		this.attachEvents();
	}
	attachEvents() {
		const self = this;
		utilities.emitter.on("window/scroll", function(obj) {
			let width =
				window.innerWidth ||
				document.documentElement.clientWidth ||
				document.body.clientWidth;
			if (self.timeout) {
				clearTimeout(this.timeout);
			}
			self.timeout = setTimeout(() => {
				if (
					obj.direction == "up" &&
					(width > self.mobileBreakpoint || obj.top <= 50)
				) {
					self.headers.forEach(element => {
						element.classList.remove("header--hide");
					});
				} else if (obj.direction == "down") {
					if (obj.top > 50) {
						self.headers.forEach(element => {
							element.classList.add("header--hide");
						});
					}
				}
			}, 50);
		});
	}
}
